import type { PriceDaily } from "epsm-api-types/models";
import { SectorsTimeRange } from "../../../types";

const START_HOURS = 9;
const END_HOURS = 16;

export function getStocksByTimeRange(
	stocks: PriceDaily[],
	timeRange: SectorsTimeRange,
): PriceDaily[] {
	if (timeRange === SectorsTimeRange.OneYear) return stocks;

	if (timeRange === SectorsTimeRange.SixtyDays) {
		const tickerGroups = stocks.reduce(
			(groups, stock) => {
				const ticker = stock.ticker;

				if (!groups[ticker]) {
					groups[ticker] = [];
				}

				groups[ticker].push(stock);
				return groups;
			},
			{} as Record<string, PriceDaily[]>,
		);

		const daysOffset = Number.parseInt(timeRange.replace(/\D/g, ""));

		return Object.values(tickerGroups).flatMap((tickerStocks) =>
			tickerStocks.slice(-daysOffset),
		);
	}

	if (timeRange === SectorsTimeRange.FifteenDays) {
		return stocks.filter((stock) => {
			const stockTime = new Date(stock.date);
			const hours = stockTime.getHours();

			return hours >= START_HOURS && hours <= END_HOURS;
		});
	}

	return stocks;
}
